import React from 'react';
import {
  isAndroidChrome,
  isIOS,
} from '../../../../../helpers/serverRenderingUtils';
import {
  AppStoreButton,
  PlayStoreButton,
} from '../../../../components/AppDownloadButtons';

const AppStoreDownloadButton = ({ white }) => {
  if (isAndroidChrome()) return <PlayStoreButton width={181} />;
  if (isIOS()) return <AppStoreButton width={181} white={white} />;
  return <AppStoreButton width={181} white={white} />;
};

export { AppStoreDownloadButton as default, AppStoreDownloadButton };
